import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../Firebase_Config/firebase";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import './AccountMang.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState('success');
  const [toastMessage, setToastMessage] = useState('');

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') return;
    setToastOpen(false);
  };

  const showToast = (message, severity = 'success') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      showToast('Please enter your email.', 'warning');
      return;
    }

    sendPasswordResetEmail(auth, email)
      .then(() => {
        showToast("Check your email for password reset instructions.", 'success');
      })
      .catch((error) => {
        showToast(error.message, 'error');
      });
  };
  const d = new Date();
    let year = d.getFullYear();
  return (
    <div style={{
      backgroundImage: `linear-gradient(195deg, rgba(66, 66, 74, 0.6), rgba(25, 25, 25, 0.6)), url('bg.jpeg')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      height: '100vh'
    }}>
      <div className="auth-container">
        <div className="auth-box">
          <div className="sign-in-header">
            <h2 className="Signh2">Forgot Password</h2>
          </div>
          <div>
            <form onSubmit={handleSubmit}>
              <input
                className="form_input"
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Email Here..."
              />
              <button className="Signbutton" type="submit">Reset</button>
            </form>
            <p className="sign-up-text">
              Already have an account? <a href="/SignIn">Sign In</a>
            </p>
          </div>
        </div>
      </div>

      <Snackbar
        open={toastOpen}
        autoHideDuration={4000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert
          onClose={handleCloseToast}
          severity={toastSeverity}
          elevation={6}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {toastMessage}
        </MuiAlert>
      </Snackbar>

      <p className='copyright sign'>© Copyright, {year} Assentian. All Rights Reserved</p>
    </div>
  );
}

export default ForgotPassword;
